import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Badge } from '../../Badge';
import styles from './TournamentCard.css';

const cx = classnames.bind(styles);

function TournamentCard({date, imageUrl, name, className, backgroundImageUrl, onClick, registrationState, description}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    const handleClick = () => {
        onClick?.();
    };

    return (
        <div
            className={classes}
            onClick={handleClick}
        >
            <div
                className={styles.imageWrap}
                style={{backgroundImage: `url(${backgroundImageUrl})`}}
            >
                <img
                    className={styles.image}
                    src={imageUrl}
                    alt={name}
                    loading='lazy'
                />
            </div>
            <div className={styles.infoWrap}>
                <p className={styles.date}>{date}</p>
                <div className={styles.badges}>
                    <Badge
                        type='neutral'
                        className={styles.badge}
                    >
                        {description}
                    </Badge>
                    <Badge
                        type={registrationState}
                        className={styles.badge}
                    >
                        {registrationState}
                    </Badge>
                </div>
            </div>
            <h3 className={styles.name}>
                {name}
            </h3>
        </div>
    );
}

TournamentCard.propTypes = {
    backgroundImageUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    registrationState: PropTypes.string.isRequired,
    className: PropTypes.string,
    description: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export {
    TournamentCard
};
